export default __webpack_public_path__ + "static/media/Step.86e59e72.png";